import { render } from "./ConfirmItem.vue?vue&type=template&id=0bc245f3&scoped=true"
import script from "./ConfirmItem.vue?vue&type=script&lang=js"
export * from "./ConfirmItem.vue?vue&type=script&lang=js"

import "./ConfirmItem.vue?vue&type=style&index=0&id=0bc245f3&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0bc245f3"

export default script